<template>
  <b-container>
    <h4 class="mb-3">Loading Results <span v-if="text.length > 0">for <b>"{{ text }}"</b></span> </h4>
    <div class="spinner-load"><b-spinner variant="primary" label="loading"></b-spinner></div>
  </b-container>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
  .spinner-load {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4rem;
  }
</style>
